import React from 'react';

import { StatusButton } from '../../../../../../../../../../components/library';
import { getStatusButtonMenuOptions } from '../../../../../../../../../../components/StatusButton/reactQueryUtil';
import { InsuredProfilePageDuskIds } from '../../../../../../../../../../constants/duskIds';
import { useUpdateAttachmentStatus } from '../../../../../../../../../../services/attachment-service';

export const COLUMNS = [
  {
    Header: 'File Name',
    accessor: 'name'
  },
  {
    Header: 'Upload Date',
    accessor: 'uploaded',
    Cell: ({ row: { original } }) => original.createdAt.split('T')[0]
  },
  {
    Header: 'Options',
    accessor: 'status',
    Cell: ({ cell: { value }, row: { original } }) => {
      const { attachableId: recordId } = original;

      const { mutate: archiveAttachment } = useUpdateAttachmentStatus({ recordId, status: 'archived' });
      const { mutate: deleteAttachment } = useUpdateAttachmentStatus({ recordId, status: 'deleted' });
      const { mutate: activateAttachment } = useUpdateAttachmentStatus({ recordId, status: 'active' });

      const options = getStatusButtonMenuOptions(value, 'attachments');

      return (
        <StatusButton
          duskSelector={InsuredProfilePageDuskIds.getArchivedAttachmentStatusButton(original.id)}
          id={original.id}
          metadata={{
            attachmentId: original.id,
            deleteAttachment,
            activateAttachment,
            archiveAttachment
          }}
          options={options}
        />
      );
    }
  }
];
